import React, { useState } from 'react';
import arrow from '../../../../../assets/image/arrow.svg';
import Table from '../../../../../component/table/Table';
import PageLoader from '../../../../../component/PageLoader';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getInvoicesList } from '../../../../../services/invoices';
import { getDate } from '../../../../../utils/dateUtils';
import { setAdvanceFilter } from '../../../../../store/action/advanceFilter';
import { useDispatch } from 'react-redux';
import { fetchPaymentsReceivedList } from '../../../../../services/payments_received';
import { getSalesReturnList } from '../../../../../services/sales_return';
import { creditNoteTableColumn } from '../../../components/tableColumns';
import { fetchCreditNoteList } from '../../../../../services/sales_credit_note';

const ArrowIcon = ({ isOpen, onClick }) => (
	<button
		onClick={onClick}
		style={{
			background: 'none',
			border: 'none',
			cursor: 'pointer',
			paddingLeft: '20px',
			transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
			transition: 'transform 0.3s ease',
		}}
		aria-label="Toggle section"
	>
		<img
			src={arrow}
			alt="Arrow Icon"
		/>
	</button>
);

const FaqSection = ({ customer }) => {
	const [openSection, setOpenSection] = useState(null);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const toggleSection = (index) => {
		setOpenSection(openSection === index ? null : index);
	};
	const [loader, setLoader] = useState(false);
	const suburl = localStorage.getItem('suburl');
	const param = useParams();
	const id = param?.id;

	const navigateRouter = (path) => {
		navigate(path);
	};
	const [tableParams, setTableParams] = useState({
		page: 1,
		page_size: 5,
		order_by: 'created_at',
		sort_by: 'desc',
		filters: {
			customer_id: id,
		},
	});
	const [tableData, setTableData] = useState({
		currentPage: 1,
		totalPages: 1,
		data: [],
	});

	async function handleFetchTableData(index) {
		if (index === 0) {
			try {
				setLoader(true);
				const { invoices, total_pages } = await getInvoicesList(tableParams);
				const invoiceList = invoices.map((ele) => {
					return {
						id: ele.id,
						DATE: getDate(ele.date),
						INVOICE: ele.invoice_number || 'N/A',
						STATUS: ele?.status || 'N/A',
						AMOUNT: ele?.total_amount || 'N/A',
					};
				});
				setTableData((prev) => ({
					...prev,
					data: invoiceList,
					totalPages: total_pages,
				}));
			} catch (error) {
				toast.error('Something went wrong!');
			} finally {
				setLoader(false);
			}
		} else if (index === 1) {
			try {
				setLoader(true);
				const { payment_receives, total_pages } = await fetchPaymentsReceivedList(tableParams);
				const paymentReceivesList = payment_receives.map((pr) => {
					return {
						id: pr.id,
						DATE: getDate(pr?.date),
						'PR#': pr?.payment_receive_number,
						'CUSTOMER NAME': pr?.customer?.name || 'N/A',
						'PAYMENT MODE': pr?.payment_mode?.payment_method_name || 'N/A',
						AMOUNT: pr?.used_payment_amount || 'N/A',
						'UNUSED AMOUNT': pr?.excess_payment_amount || 'N/A',
					};
				});
				setTableData((prev) => ({
					...prev,
					data: paymentReceivesList,
					totalPages: total_pages,
				}));
			} catch (error) {
				toast.error(error.message || 'Something went wrong!');
			} finally {
				setLoader(false);
			}
		} else if (index === 2) {
			try {
				setLoader(true);
				const { sales_return, total_pages } = await getSalesReturnList(tableParams);
				const sales_return_list = sales_return.map((ele) => {
					return {
						id: ele?.id,
						DATE: getDate(ele?.date),
						'SALES RETURN#': ele?.return_number,
						'CUSTOMER NAME': ele.customer?.name || 'N/A',
						STATUS: ele?.status || 'N/A',
						'RECEIVED STATUS': ele?.received_status || 'N/A',
						'REFUND MODE': ele?.payment_mode?.payment_method_name || 'N/A',
						AMOUNT: ele?.bill_total || 'N/A',
					};
				});
				setTableData((prev) => ({
					...prev,
					data: sales_return_list,
					totalPages: total_pages,
				}));
			} catch (error) {
				toast.error(error.message || 'Something went wrong!');
			} finally {
				setLoader(false);
			}
		} else if (index === 3) {
			try {
				setLoader(true);
				var { credit_notes, total_pages } = await fetchCreditNoteList(tableParams);
				const salesCreditNote = credit_notes.map((ele) => {
					return {
						id: ele.id,
						DATE: getDate(ele.date),
						'CREDIT NOTE #': ele?.credit_note_number || 'N/A',
						'CUSTOMER NAME': ele.customer?.name || 'N/A',
						STATUS: ele?.status,
						TYPE:
							ele?.credit_note_type === 1
								? 'Damaged/Return Goods'
								: ele?.credit_note_type === 2
									? 'Excess Payment'
									: 'Advance Payment',
						AMOUNT: ele?.total_credit_amount,
					};
				});
				setTableData((prev) => ({
					...prev,
					data: salesCreditNote,
					totalPages: total_pages,
				}));
			} catch (error) {
				toast.error(error.message || 'Something went wrong!');
			} finally {
				setLoader(false);
			}
		}
	}

	function handleCreateButton(index) {
		let baseUrl = `/user/${suburl}/`;
		const urlMap = {
			0: baseUrl + `invoices-create`,
			1: baseUrl + `payments-received-create`,
			2: baseUrl + `sales-return-create`,
			3: baseUrl + `sales/credit-note-create`,
		};

		navigate(urlMap[Number(index)], { state: customer });
	}
	function handleListButton(index) {
		let baseUrl = `/user/${suburl}/`;
		const urlMap = {
			0: baseUrl + `invoices`,
			1: baseUrl + `payments-received`,
			2: baseUrl + `sales-return`,
			3: baseUrl + `sales/credit-note`,
		};

		const params = {
			page: 1,
			totalPages: 0,
			pageSize: 20,
			filters: {
				customer_name: customer.value,
			},
			isAdvanceFilterApplied: true,
			selectedInputs: [
				{
					key: 'customer_name',
					label: 'Customer Name',
					data: [
						{
							key: customer?.value,
							value: customer?.value,
						},
					],
					value: customer?.value,
				},
			],
		};
		dispatch(setAdvanceFilter(params));
		navigate(urlMap[Number(index)], { state: customer });
	}

	const faqData = [
		{
			title: 'Invoices',
			columns: [
				{
					field: 'DATE',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 150,
					maxWidth: 150,
					flex: 1,
					cellClass: 'left-align',
				},
				{
					field: 'INVOICE',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 220,
					flex: 1,
					cellClass: 'left-align',
				},
				{
					field: 'STATUS',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 150,
					flex: 1,
					cellClass: 'left-align',
				},
				{
					field: 'AMOUNT',
					headerClass: 'HeaderBg right-align',
					suppressSizeToFit: true,
					minWidth: 150,
					maxWidth: 300,
					flex: 1,
					cellClass: 'right-align',
				},
			],
		},
		{
			title: 'Payments Received',
			columns: [
				{
					field: 'DATE',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 150,
					maxWidth: 150,
					flex: 1,
					cellClass: 'left-align',
				},
				{
					field: 'PR#',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 150,
					maxWidth: 150,
					flex: 1,
					cellClass: 'left-align',
				},
				{
					field: 'CUSTOMER NAME',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 220,
					flex: 1,
					cellClass: 'left-align',
				},
				{
					field: 'PAYMENT MODE',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 150,
					flex: 1,
					cellClass: 'left-align',
				},
				{
					field: 'AMOUNT',
					headerClass: 'HeaderBg right-align',
					suppressSizeToFit: true,
					minWidth: 150,
					maxWidth: 300,
					flex: 1,
					cellClass: 'right-align',
				},
				{
					field: 'UNUSED AMOUNT',
					headerClass: 'HeaderBg right-align',
					suppressSizeToFit: true,
					minWidth: 150,
					maxWidth: 300,
					flex: 1,
					cellClass: 'right-align',
				},
			],
		},
		{
			title: 'Sales Return',
			columns: [
				{
					field: 'DATE',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 150,
					maxWidth: 150,
					flex: 1,
					cellClass: 'left-align',
				},
				{
					field: 'SALES RETURN#',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 220,
					maxWidth: 250,
					flex: 1,
					cellClass: 'left-align',
				},
				{
					field: 'CUSTOMER NAME',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 220,
					flex: 1,
					cellClass: 'left-align',
				},
				{
					field: 'STATUS',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 150,
					flex: 1,
					cellClass: 'left-align',
				},
				{
					field: 'RECEIVED STATUS',
					headerClass: 'HeaderBg right-align',
					suppressSizeToFit: true,
					minWidth: 150,
					maxWidth: 300,
					flex: 1,
					cellClass: 'right-align',
				},
				{
					field: 'REFUND MODE',
					headerClass: 'HeaderBg right-align',
					suppressSizeToFit: true,
					minWidth: 150,
					maxWidth: 300,
					flex: 1,
					cellClass: 'right-align',
				},
				{
					field: 'AMOUNT',
					headerClass: 'HeaderBg right-align',
					suppressSizeToFit: true,
					minWidth: 150,
					maxWidth: 300,
					flex: 1,
					cellClass: 'right-align',
				},
			],
		},
		{
			title: 'Credit Notes',
			columns: creditNoteTableColumn,
		},
	];
	return (
		<div>
			{faqData.map((section, index) => (
				<div
					key={index}
					style={{ marginBottom: '8px' }}
				>
					{/* Section Header */}
					<div
						style={{
							cursor: 'pointer',
							background: '#F6F6F9',
							display: 'flex',
							height: '58px',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}
						onClick={() => {
							toggleSection(index);
							handleFetchTableData(index);
							setTableData({
								currentPage: 1,
								totalPages: 0,
								data: [],
							});
						}}
					>
						{/* Left Arrow Icon */}
						<div
							onClick={() => {
								toggleSection(index);
								handleFetchTableData(index);
								setTableData({
									currentPage: 1,
									totalPages: 0,
									data: [],
								});
							}}
							style={{ display: 'flex', alignItems: 'center' }}
						>
							<ArrowIcon isOpen={openSection === index} />
							<span style={{ marginLeft: '0px' }}>{section.title}</span>
						</div>

						{/* Right "New +" Button */}
						<button
							onClick={() => {
								handleCreateButton(index);
							}}
							style={{
								backgroundColor: '#3B58FF',
								fontSize: '16',
								fontWeight: '600',
								marginRight: '8px',
								width: '84px',
								height: '42px',
								color: 'white',
								border: 'none',
								borderRadius: '6px',
								cursor: 'pointer',
							}}
						>
							New +
						</button>
					</div>

					{/* Section Content */}
					{openSection === index && (
						<div style={{ borderBottom: '1px solid #ccc', backgroundColor: '#F6F6F9' }}>
							{loader ? (
								<PageLoader />
							) : (
								<>
									{/* Table Content */}
									<div style={styles.tableContainer}>
										<Table
											coloum={section.columns}
											row={tableData?.data}
											onRowClick={(rowId) => {
												if (index === 0) {
													navigateRouter(`/user/${suburl}/invoices-details/${rowId}`);
												} else if (index === 1) {
													navigateRouter(`/user/${suburl}/payments-received-details/${rowId}`);
												} else if (index === 2) {
													navigateRouter(`/user/${suburl}/sales-return-details/${rowId}`);
												}
											}}
										/>
									</div>
									<div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
										<button
											style={{
												fontSize: '16',
												fontWeight: '600',
												marginRight: '8px',
												width: '84px',
												height: '42px',
												color: 'black',
												border: '1px solid #3B58FF',
												background: 'transparent',
												padding: '4px 8px',
												marginBottom: '7px',
												borderRadius: '6px',
												cursor: 'pointer',
											}}
											onClick={() => handleListButton(index)}
										>
											View All
										</button>
									</div>
								</>
							)}
						</div>
					)}
				</div>
			))}
		</div>
	);
};

const styles = {
	tableContainer: {
		width: '100%',
		maxHeight: '300px',
		overflowY: 'hidden',
	},
};

export default FaqSection;
